export default __webpack_public_path__ + "static/media/heart.30d1d870.svg";